module.exports = __webpack_public_path__ + "img/LINE_Brand_icon.37b0675d.png";